import React from 'react';
import styles from './FormTextField.module.scss';
import TextField from '@material-ui/core/TextField';

import { makeStyles } from '@material-ui/core/styles';
import { IconButton, InputAdornment } from '@material-ui/core';
import { Close, DragIndicator } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
    root: {
        '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline > legend': {
                width: 0,
            },
        },
        '& .MuiInputLabel-outlined': {
            transform: 'translate(9px, 12px) scale(1)',
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            color: 'gray',
        },
    },
    pointer: {
        cursor: "pointer",
    },
}));

interface FormTextFieldProps {
    id: string;
    title: string;
    value: string;
    placeholder?: boolean;
    label?: boolean;
    isRequired?: boolean;
    isDraggable?: boolean;
    isRemovable?: boolean;
    isEditable?: boolean;
    isMultiline?: boolean;
    prefixIcon?: React.ReactElement;
    autoComplete?: string;
    onClick?: (_id: string) => void;
    onChange: (_key: string, _value: string) => void;
    onRemove?: (_key: string) => void;
};

const FormTextField = ({
    id,
    title,
    value,
    placeholder,
    label,
    isRequired = false,
    isDraggable = false,
    isRemovable = false,
    isEditable = false,
    isMultiline = false,
    prefixIcon,
    autoComplete = '',
    onClick,
    onChange,
    onRemove,
}: FormTextFieldProps) => {
    const customStyles = useStyles();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        onChange(id, value);
    };

    const clickHanlder = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target;
        if (target instanceof HTMLButtonElement || target instanceof SVGElement) {
            return;
        }
        isEditable && onClick && onClick(id);
    };

    return (
        <div className={styles.container}
            onClick={clickHanlder}>
            {label &&
                <label htmlFor={id}>{title}</label>
            }
            <div className={styles.inputContainer}>
                <TextField
                    id={id}
                    className={customStyles.root}
                    variant="outlined"
                    label={!value && placeholder &&
                        <div style={{ paddingLeft: prefixIcon ? '40px' : '' }}>
                            {title}
                            {isRequired && <span style={{ color: 'red' }}> *</span>}
                        </div>
                    }
                    value={value || ""}
                    onChange={handleChange}
                    fullWidth
                    style={isMultiline ? { height: 120 } : undefined}
                    InputProps={{
                        ...(autoComplete ? { autoComplete } : {}),
                        ...(isMultiline && {
                            style: { height: 120, alignItems: 'flex-start' },
                        }),
                        ...(prefixIcon && {
                            startAdornment: (
                                <InputAdornment position="start">
                                    {prefixIcon}
                                </InputAdornment>
                            ),
                        }),
                        ...(isEditable && onClick && {
                            classes: { input: customStyles.pointer },
                        }),
                    }}
                />
                {(isDraggable || isRemovable) &&
                    <div className={isMultiline ? styles.actionsMultiline : styles.actions}>
                        {isRemovable && onRemove &&
                            <IconButton onClick={() => onRemove(id)}>
                                <Close />
                            </IconButton>
                        }
                        {isDraggable &&
                            <IconButton>
                                <DragIndicator />
                            </IconButton>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default FormTextField;
